type TitleResolver = { match: RegExp; labelId: string };

const centerTitleResolvers: TitleResolver[] = [
  { match: /^\/environment-center(\/|$)/, labelId: "menu.environmentCenter" },
  { match: /^\/instance-center(\/|$)/, labelId: "menu.instanceCenter" },
  { match: /^\/orchestrator-center(\/|$)/, labelId: "menu.orchestratorCenter" },
  { match: /^\/task-center(\/|$)/, labelId: "menu.taskCenter" },
  { match: /^\/execution-center(\/|$)/, labelId: "menu.executionCenter" },
  { match: /^\/identity(\/|$)/, labelId: "menu.identity" },
  { match: /^\/assets-center(\/|$)/, labelId: "menu.assetsCenter" },
  { match: /^\/portal(\/|$)/, labelId: "menu.portalManagement" },
  { match: /^\/intelligence-center(\/|$)/, labelId: "menu.intelligenceCenter" },
  { match: /^\/ops-center(\/|$)/, labelId: "menu.opsCenter" },
  { match: /^\/capability-graph(\/|$)/, labelId: "menu.capabilityGraph" },
  { match: /^\/tactics-techniques-hub(\/|$)/, labelId: "menu.tacticsTechniquesHub" },
  { match: /^\/vulnerability-library(\/|$)/, labelId: "menu.vulnerabilityLibrary" },
  { match: /^\/business-reference-center(\/|$)/, labelId: "menu.businessReferenceCenter" },
  { match: /^\/tools-library(\/|$)/, labelId: "menu.toolsLibrary" },
  { match: /^\/traffic-library(\/|$)/, labelId: "menu.trafficLibrary" },
  { match: /^\/knowledge-library(\/|$)/, labelId: "menu.knowledgeLibrary" },
  { match: /^\/centers(\/|$)/, labelId: "menu.centers" },
];

const pageTitleResolvers: TitleResolver[] = [
  { match: /^\/dashboard$/, labelId: "menu.dashboard" },
  { match: /^\/portal\/appearance$/, labelId: "menu.portalManagement.portalAppearance" },
  { match: /^\/portal\/ui-semantics$/, labelId: "menu.portalManagement.portalUiSemantics" },
  { match: /^\/portal\/groups$/, labelId: "menu.portalManagement.portalGroups" },
  { match: /^\/portal\/entries$/, labelId: "menu.portalManagement.portalEntries" },
  { match: /^\/portal\/access$/, labelId: "menu.portalManagement.portalAccess" },
  { match: /^\/portal\/security$/, labelId: "menu.portalManagement.portalSecurity" },
  { match: /^\/identity\/dashboard$/, labelId: "menu.identity.dashboard" },
  { match: /^\/identity\/applications$/, labelId: "menu.identity.identityApplications" },
  { match: /^\/identity\/tenants$/, labelId: "menu.identity.identityTenants" },
  { match: /^\/identity\/organizations$/, labelId: "menu.identity.identityOrganizations" },
  { match: /^\/identity\/users$/, labelId: "menu.identity.identityUsers" },
  { match: /^\/identity\/user-custom-fields$/, labelId: "menu.identity.identityUserCustomFields" },
  { match: /^\/identity\/roles$/, labelId: "menu.identity.identityRoles" },
  { match: /^\/identity\/permissions$/, labelId: "menu.identity.identityPermissions" },
  { match: /^\/identity\/events$/, labelId: "menu.identity.identityEvents" },
  { match: /^\/identity\/login-records$/, labelId: "menu.identity.identityLoginRecords" },
  { match: /^\/centers$/, labelId: "menu.centers" },
  { match: /^\/ops-center\/dashboard$/, labelId: "menu.opsCenter.opsCenterDashboard" },
  { match: /^\/assets-center\/dashboard$/, labelId: "menu.assetsCenter.assetsDashboard" },
  { match: /^\/assets-center\/assets$/, labelId: "menu.assetsCenter.assetsGovernance" },
  { match: /^\/assets-center\/object-spaces$/, labelId: "menu.assetsCenter.assetsObjectSpaces" },
  { match: /^\/assets-center\/references$/, labelId: "menu.assetsCenter.assetsReferences" },
  {
    match: /^\/assets-center\/public-branding$/,
    labelId: "menu.assetsCenter.assetsPublicBranding",
  },
  {
    match: /^\/environment-center\/dashboard$/,
    labelId: "menu.environmentCenter.environmentDashboard",
  },
  {
    match: /^\/environment-center\/container-specs$/,
    labelId: "menu.environmentCenter.environmentContainer.environmentContainerSpecs",
  },
  {
    match: /^\/environment-center\/vm-specs$/,
    labelId: "menu.environmentCenter.environmentKvm.environmentVmSpecs",
  },
  {
    match: /^\/environment-center\/dynamips-ios-images$/,
    labelId: "menu.environmentCenter.environmentDynamips.environmentDynamipsIosImages",
  },
  {
    match: /^\/environment-center\/dynamips-specs$/,
    labelId: "menu.environmentCenter.environmentDynamips.environmentDynamipsSpecs",
  },
  {
    match: /^\/environment-center\/microvm-specs$/,
    labelId: "menu.environmentCenter.environmentFirecracker.environmentMicrovmSpecs",
  },
  {
    match: /^\/environment-center\/firecracker-kernels$/,
    labelId: "menu.environmentCenter.environmentFirecracker.environmentFirecrackerKernels",
  },
  {
    match: /^\/environment-center\/firecracker-rootfs-images$/,
    labelId: "menu.environmentCenter.environmentFirecracker.environmentFirecrackerRootfsImages",
  },
  {
    match: /^\/environment-center\/firecracker-application-images$/,
    labelId:
      "menu.environmentCenter.environmentFirecracker.environmentFirecrackerApplicationImages",
  },
  {
    match: /^\/environment-center\/base-images$/,
    labelId: "menu.environmentCenter.environmentKvm.environmentBaseImages",
  },
  {
    match: /^\/environment-center\/image-artifact-tasks$/,
    labelId: "menu.environmentCenter.environmentKvm.environmentImageArtifactTasks",
  },
  {
    match: /^\/environment-center\/application-images$/,
    labelId: "menu.environmentCenter.environmentKvm.environmentApplicationImages",
  },
  {
    match: /^\/environment-center\/custom-images$/,
    labelId: "menu.environmentCenter.environmentKvm.environmentCustomImages",
  },
  {
    match: /^\/environment-center\/container-images$/,
    labelId: "menu.environmentCenter.environmentContainer.environmentContainerImages",
  },
  {
    match: /^\/environment-center\/image-port-service-protocols$/,
    labelId: "menu.environmentCenter.environmentImagePortServiceProtocols",
  },
  {
    match: /^\/environment-center\/system-core-images$/,
    labelId: "menu.environmentCenter.environmentKvm.environmentSystemCoreImages",
  },
  {
    match: /^\/environment-center\/physical-devices$/,
    labelId: "menu.environmentCenter.environmentPhysicalDevices",
  },
  {
    match: /^\/environment-center\/topology-templates$/,
    labelId: "menu.environmentCenter.environmentTopology.environmentTopologyTemplates",
  },
  {
    match: /^\/environment-center\/topology-versions$/,
    labelId: "menu.environmentCenter.environmentTopology.environmentTopologyVersions",
  },
  {
    match: /^\/environment-center\/topology-default-image-policy$/,
    labelId: "menu.environmentCenter.environmentTopology.environmentTopologyDefaultImagePolicy",
  },
  {
    match: /^\/environment-center\/cloud-init-profiles$/,
    labelId: "menu.environmentCenter.environmentKvm.environmentCloudInitProfiles",
  },
  {
    match: /^\/environment-center\/simulator-models$/,
    labelId: "menu.environmentCenter.environmentSimulator.environmentSimulatorModels",
  },
  { match: /^\/instance-center\/dashboard$/, labelId: "menu.instanceCenter.instanceDashboard" },
  {
    match: /^\/instance-center\/vm-instances$/,
    labelId: "menu.instanceCenter.instanceVmInstances",
  },
  {
    match: /^\/instance-center\/vm-instances\/[^/]+$/,
    labelId: "platform.instanceCenter.vmInstances.detailTitle",
  },
  {
    match: /^\/instance-center\/container-instances$/,
    labelId: "menu.instanceCenter.instanceContainerInstances",
  },
  {
    match: /^\/instance-center\/container-instances\/[^/]+$/,
    labelId: "platform.instanceCenter.containerInstances.detailTitle",
  },
  {
    match: /^\/instance-center\/topology-instances$/,
    labelId: "menu.instanceCenter.instanceTopologyInstances",
  },
  {
    match: /^\/instance-center\/topology-instances\/[^/]+$/,
    labelId: "platform.instanceCenter.topology.detailTitle",
  },
  {
    match: /^\/instance-center\/remote-sessions$/,
    labelId: "menu.instanceCenter.instanceRemoteSessions",
  },
  {
    match: /^\/instance-center\/user-virtualization-quotas\/users$/,
    labelId:
      "menu.instanceCenter.instanceUserVirtualizationQuotas.instanceUserVirtualizationQuotaUsers",
  },
  {
    match: /^\/instance-center\/user-virtualization-quotas\/policy$/,
    labelId:
      "menu.instanceCenter.instanceUserVirtualizationQuotas.instanceUserVirtualizationQuotaPolicy",
  },
  {
    match: /^\/instance-center\/user-virtualization-quotas\/profiles$/,
    labelId:
      "menu.instanceCenter.instanceUserVirtualizationQuotas.instanceUserVirtualizationQuotaProfiles",
  },
  {
    match: /^\/instance-center\/user-virtualization-quotas\/leases$/,
    labelId:
      "menu.instanceCenter.instanceUserVirtualizationQuotas.instanceUserVirtualizationQuotaLeases",
  },
  {
    match: /^\/instance-center\/user-virtualization-quotas$/,
    labelId: "menu.instanceCenter.instanceUserVirtualizationQuotas",
  },
  {
    match: /^\/orchestrator-center\/dashboard$/,
    labelId: "menu.orchestratorCenter.orchestratorDashboard",
  },
  {
    match: /^\/orchestrator-center\/capability-map$/,
    labelId: "menu.orchestratorCenter.orchestratorCapabilityMap",
  },
  {
    match: /^\/orchestrator-center\/requests$/,
    labelId: "menu.orchestratorCenter.orchestratorRequests",
  },
  {
    match: /^\/orchestrator-center\/recycles$/,
    labelId: "menu.orchestratorCenter.orchestratorRecycles",
  },
  {
    match: /^\/orchestrator-center\/actions$/,
    labelId: "menu.orchestratorCenter.orchestratorActions",
  },
  { match: /^\/task-center\/dashboard$/, labelId: "menu.taskCenter.taskCenterDashboard" },
  { match: /^\/task-center\/tasks$/, labelId: "menu.taskCenter.taskCenterTasks" },
  { match: /^\/task-center\/events$/, labelId: "menu.taskCenter.taskCenterEvents" },
  { match: /^\/task-center\/error-codes$/, labelId: "menu.taskCenter.taskCenterErrorCodes" },
  { match: /^\/execution-center\/dashboard$/, labelId: "menu.executionCenter.executionDashboard" },
  {
    match: /^\/execution-center\/scheduling$/,
    labelId: "menu.executionCenter.executionScheduling",
  },
  { match: /^\/execution-center\/instances$/, labelId: "menu.executionCenter.executionInstances" },
  { match: /^\/execution-center\/providers$/, labelId: "menu.executionCenter.executionProviders" },
  { match: /^\/execution-center\/targets$/, labelId: "menu.executionCenter.executionTargets" },
  { match: /^\/execution-center\/nodes$/, labelId: "menu.executionCenter.executionNodes" },
  {
    match: /^\/execution-center\/node-heartbeats$/,
    labelId: "menu.executionCenter.executionNodeHeartbeats",
  },
  { match: /^\/execution-center\/docker$/, labelId: "menu.executionCenter.executionDocker" },
  { match: /^\/execution-center\/vm$/, labelId: "menu.executionCenter.executionVm" },
  {
    match: /^\/intelligence-center\/dashboard$/,
    labelId: "menu.intelligenceCenter.intelligenceCenterDashboard",
  },
  {
    match: /^\/intelligence-center\/model-connections$/,
    labelId: "menu.intelligenceCenter.intelligenceModelConnections",
  },
  {
    match: /^\/intelligence-center\/provider-configs$/,
    labelId: "menu.intelligenceCenter.intelligenceProviderConfigs",
  },
  {
    match: /^\/intelligence-center\/task-runs$/,
    labelId: "menu.intelligenceCenter.intelligenceTaskRuns",
  },
  {
    match: /^\/intelligence-center\/audit-logs$/,
    labelId: "menu.intelligenceCenter.intelligenceAuditLogs",
  },
  { match: /^\/ops-center\/modules$/, labelId: "menu.opsCenter.opsCenterModules" },
  { match: /^\/ops-center\/service-endpoints$/, labelId: "menu.opsCenter.opsCenterModules" },
  { match: /^\/ops-center\/logs$/, labelId: "menu.opsCenter.opsCenterLogs" },
  { match: /^\/ops-center\/mq-observability$/, labelId: "menu.opsCenter.opsCenterMqObservability" },
  {
    match: /^\/ops-center\/redis-observability$/,
    labelId: "menu.opsCenter.opsCenterRedisObservability",
  },
  {
    match: /^\/ops-center\/worker-observability$/,
    labelId: "menu.opsCenter.opsCenterWorkerObservability",
  },
  {
    match: /^\/ops-center\/event-delivery-observability$/,
    labelId: "menu.opsCenter.opsCenterEventDeliveryObservability",
  },
  {
    match: /^\/ops-center\/execution-chain-observability$/,
    labelId: "menu.opsCenter.opsCenterExecutionChainObservability",
  },
  {
    match: /^\/ops-center\/contract-health-observability$/,
    labelId: "menu.opsCenter.opsCenterContractHealthObservability",
  },
  {
    match: /^\/ops-center\/auth-health-observability$/,
    labelId: "menu.opsCenter.opsCenterAuthHealthObservability",
  },
  {
    match: /^\/business-reference-center\/dashboard$/,
    labelId: "menu.businessReferenceCenter.businessReferenceCenterDashboard",
  },
  {
    match: /^\/capability-graph\/dashboard$/,
    labelId: "menu.capabilityGraph.capabilityGraphDashboard",
  },
  {
    match: /^\/capability-graph\/capabilities$/,
    labelId: "menu.capabilityGraph.capabilityGraphCapabilities",
  },
  {
    match: /^\/capability-graph\/capabilities\/[^/]+$/,
    labelId: "menu.capabilityGraph.capabilityGraphCapabilityDetail",
  },
  {
    match: /^\/capability-graph\/ksa-categories$/,
    labelId: "menu.capabilityGraph.capabilityGraphKsaCategories",
  },
  {
    match: /^\/capability-graph\/ksa-categories\/knowledge$/,
    labelId:
      "menu.capabilityGraph.capabilityGraphKsaCategories.capabilityGraphKsaKnowledgeCategories",
  },
  {
    match: /^\/capability-graph\/ksa-categories\/skill$/,
    labelId: "menu.capabilityGraph.capabilityGraphKsaCategories.capabilityGraphKsaSkillCategories",
  },
  {
    match: /^\/capability-graph\/ksa-categories\/ability$/,
    labelId:
      "menu.capabilityGraph.capabilityGraphKsaCategories.capabilityGraphKsaAbilityCategories",
  },
  { match: /^\/capability-graph\/graph$/, labelId: "menu.capabilityGraph.capabilityGraphGraph" },
  {
    match: /^\/tactics-techniques-hub\/dashboard$/,
    labelId: "menu.tacticsTechniquesHub.tacticsTechniquesDashboard",
  },
  {
    match: /^\/tactics-techniques-hub\/frameworks$/,
    labelId: "menu.tacticsTechniquesHub.tacticsTechniquesFrameworks",
  },
  {
    match: /^\/tactics-techniques-hub\/binding-playground$/,
    labelId: "menu.tacticsTechniquesHub.tacticsTechniquesBindingPlayground",
  },
  {
    match: /^\/tactics-techniques-hub\/api-reference$/,
    labelId: "menu.tacticsTechniquesHub.tacticsTechniquesApiReference",
  },
  {
    match: /^\/tactics-techniques-hub\/frameworks\/[^/]+\/matrix$/,
    labelId: "menu.tacticsTechniquesHub.tacticsTechniquesFrameworkMatrix",
  },
  {
    match: /^\/tactics-techniques-hub\/frameworks\/[^/]+\/tree$/,
    labelId: "menu.tacticsTechniquesHub.tacticsTechniquesFrameworkTree",
  },
  {
    match: /^\/tactics-techniques-hub\/frameworks\/[^/]+\/version-mappings$/,
    labelId: "menu.tacticsTechniquesHub.tacticsTechniquesFrameworkVersionMappings",
  },
  {
    match: /^\/vulnerability-library\/dashboard$/,
    labelId: "menu.vulnerabilityLibrary.vulnerabilityLibraryDashboard",
  },
  {
    match: /^\/vulnerability-library\/vulnerabilities$/,
    labelId: "menu.vulnerabilityLibrary.vulnerabilityLibraryVulnerabilities",
  },
  {
    match: /^\/vulnerability-library\/vulnerabilities\/[^/]+$/,
    labelId: "menu.vulnerabilityLibrary.vulnerabilityLibraryVulnerabilityDetail",
  },
  {
    match: /^\/vulnerability-library\/source-records$/,
    labelId: "menu.vulnerabilityLibrary.vulnerabilityLibrarySourceRecords",
  },
  {
    match: /^\/vulnerability-library\/source-records\/[^/]+$/,
    labelId: "menu.vulnerabilityLibrary.vulnerabilityLibrarySourceRecordDetail",
  },
  {
    match: /^\/vulnerability-library\/sources$/,
    labelId: "menu.vulnerabilityLibrary.vulnerabilityLibrarySources",
  },
  {
    match: /^\/vulnerability-library\/import-jobs$/,
    labelId: "menu.vulnerabilityLibrary.vulnerabilityLibraryImportJobs",
  },
  {
    match: /^\/business-reference-center\/resource-types$/,
    labelId: "menu.businessReferenceCenter.businessReferenceResourceTypes",
  },
  {
    match: /^\/business-reference-center\/relation-types$/,
    labelId: "menu.businessReferenceCenter.businessReferenceRelationTypes",
  },
  {
    match: /^\/business-reference-center\/references$/,
    labelId: "menu.businessReferenceCenter.businessReferenceReferences",
  },
  { match: /^\/tools-library\/tools$/, labelId: "menu.toolsLibrary.toolsLibraryTools" },
  { match: /^\/tools-library\/categories$/, labelId: "menu.toolsLibrary.toolsLibraryCategories" },
  {
    match: /^\/traffic-library\/packet-files$/,
    labelId: "menu.trafficLibrary.trafficLibraryPacketFiles",
  },
  {
    match: /^\/traffic-library\/categories$/,
    labelId: "menu.trafficLibrary.trafficLibraryCategories",
  },
  {
    match: /^\/knowledge-library\/items$/,
    labelId: "menu.knowledgeLibrary.knowledgeLibraryItems",
  },
  {
    match: /^\/knowledge-library\/categories$/,
    labelId: "menu.knowledgeLibrary.knowledgeLibraryCategories",
  },
];

export function resolveCenterTitleId(pathname: string): string | null {
  for (const item of centerTitleResolvers) {
    if (item.match.test(pathname)) return item.labelId;
  }
  return null;
}

export function resolvePageTitleId(pathname: string): string | null {
  for (const item of pageTitleResolvers) {
    if (item.match.test(pathname)) return item.labelId;
  }
  return null;
}
